/**
 * formatPhone — global phone-number formatter snippet.
 *
 * Format rules (AU-first per owner's spec):
 *   Landline:    (99) 4444 4444
 *   Mobile 04:   4444 333 333    → i.e. no parens, groups of 4-3-3
 *   1300/1800:   1300 123 456    → 4-3-3
 *   International: +XX ... (best-effort strip + reformat)
 *
 * DB values are stored raw. This helper is the SINGLE point where AU
 * phone strings become display-ready. Never re-implement — always import.
 */

// Strip everything but digits + a leading +
function digitsOnly(str) {
  if (!str) return "";
  return String(str).replace(/[^\d+]/g, "");
}

/**
 * Format an AU phone number for display.
 * Returns the input unchanged if we can't parse it (safe fallback).
 */
export function formatPhone(input) {
  if (!input) return "";
  const raw = digitsOnly(input);
  if (!raw) return input;

  // Normalise a leading +61 → 0 for AU display
  let n = raw;
  if (n.startsWith("+61")) n = "0" + n.slice(3);
  else if (n.startsWith("0061")) n = "0" + n.slice(4);

  // Mobile: 04XX XXX XXX
  if (n.length === 10 && n.startsWith("04")) {
    return `${n.slice(0, 4)} ${n.slice(4, 7)} ${n.slice(7, 10)}`;
  }
  // 13xx / 1300 / 1800 / 1900: 4-3-3
  if (n.length === 10 && /^1[0-9]{9}$/.test(n)) {
    return `${n.slice(0, 4)} ${n.slice(4, 7)} ${n.slice(7, 10)}`;
  }
  // Landline: 0X XXXX XXXX  →  displayed as (0X) XXXX XXXX
  if (n.length === 10 && n.startsWith("0")) {
    return `(${n.slice(0, 2)}) ${n.slice(2, 6)} ${n.slice(6, 10)}`;
  }
  // 9-digit landline without leading 0 (rare in DB): X XXXX XXXX
  if (n.length === 9) {
    return `(0${n.slice(0, 1)}) ${n.slice(1, 5)} ${n.slice(5, 9)}`;
  }
  // International non-AU: leave with a single leading + and space groups of 3-4
  if (raw.startsWith("+")) {
    // best-effort: +cc followed by rest
    return raw.replace(/(\+\d{1,3})(\d{3,4})(\d{3,4})(\d{0,4})/, "$1 $2 $3 $4").trim();
  }
  return input;
}
